<template>
  <div v-if="!getDeviceType()" class="loginPage">
    <div class="loginColumn">
      <img class="loginLogo" src="@/assets/searchLogo.svg" />
      <img class="loginImage" src="@/assets/loginIcon.png" />
      <img class="loginLogoText" src="@/assets/CourseLnk.png" />
    </div>
    <div class="loginColumn">
      <form @submit.prevent="login" class="loginForm">
        <p class="loginTitle">Welcome to your online campus!</p>
        <!--input
          v-model="email"
          type="text"
          placeholder="University Email"
          name="email"
          required
        />
        <input
          v-model="password"
          type="password"
          placeholder="Password"
          name="psw"
          required
        /-->

        <div class="user-input-wrp">
          <input
            v-model="email"
            type="text"
            name="email"
            required
            placeholder=" "
            class="inputText"
          />
          <span class="floating-label">University email</span>
        </div>

        <div class="user-input-wrp">
          <input
            v-model="password"
            type="password"
            name="psw"
            required
            placeholder=" "
            class="inputText"
          />
          <span class="floating-label">Password</span>
        </div>

        <p v-if="feedback" class="feedback">{{ feedback }}</p>

        <div class="endFormLogin">
          <button type="submit" class="joinButtonSmall">Login</button>
        </div>
        <router-link class="forgotPassword" :to="{ name: 'Password' }"
          >Forgot password?</router-link
        >

        <div class="loginSignupDivider"></div>
        <div class="signupBox">
          <router-link class="joinButtonSmall toSignup" :to="{ name: 'Signup' }"
            >Create Account</router-link
          >
        </div>
      </form>
    </div>
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
  <div v-else class="loginPage">
    <div class="loginColumn"></div>
    <div class="loginColumn">
      <div @submit.prevent="login" class="loginForm formOnPhone">
        <img class="loginLogo" src="@/assets/searchLogo.svg" />
        <img class="loginLogoTextPhone" src="@/assets/CourseLnk.png" />
        <p class="loginTitle">Welcome to your online campus!</p>
        <form
          method="get"
          action="https://apps.apple.com/ca/app/courselnk/id1545799969"
        >
          <img src="../../assets/downloadOnAppStore.png" />
        </form>
        <p class="phoneText">Or access courselnk.com on a computer</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import firebase from "@/firebase";
import db from "@/db";
import router from "@/router/index.js";
export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      feedback: null,
      course: null,
    };
  },
  mounted() {
    this.getIOS();
  },
  methods: {
    getDeviceType() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return true;
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return true;
      }
      return false;
    },
    ...mapActions("groups", ["setGroupNotificationInfo", "getTimeSincePost"]),

    //Logs the user in if the correct email and password were entered
    async login() {
      if (this.email && this.password) {
        this.feedback = null;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            const user = firebase.auth().currentUser;
            this.setInitialCourse(user.uid).then(() => {
              if (this.course) {
                this.$store.commit(
                  "messageBoard/setGroupName",
                  this.course.name
                );
                this.$store.commit("messageBoard/setGroupId", this.course.id);
                this.$store.commit(
                  "messageBoard/setGroupType",
                  this.course.type
                );
                this.$store.commit("messageBoard/setCurGroup", this.course);
                db.collection("users")
                  .doc(user.uid)
                  .get()
                  .then(async (doc) => {
                    var data = doc.data();
                    data.id = user.uid;
                    this.setUserGroups(data.id);
                    this.$store.commit("user/setUser", data);
                    router.push({ name: "Profile" });
                  });
              } else {
                db.collection("users")
                  .doc(user.uid)
                  .get()
                  .then(async (doc) => {
                    var data = doc.data();
                    data.id = user.uid;
                    this.$store.commit("user/setUser", data);
                    this.$router.push({ name: "Profile" });
                  });
              }
            });
          })
          .catch(() => {
            this.feedback = "The email or password is incorrect";
          });
      } else {
        this.feedback = "Please Fill In Both Fields";
      }
    },
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
    getIOS() {
      if (this.iOS()) {
        window.location.replace("https://courselnk.page.link/share");
      }
    },
    setUserGroups(id) {
      db.collection("users")
        .doc(id)
        .get()
        .then((doc) => {
          var user = doc.data();
          user.id = doc.id;
          user.courses.forEach((course, index) => {
            db.collection("courses")
              .doc(course.id)
              .get()
              .then((doc) => {
                user.courses[
                  index
                ].hasSeenLastPost = doc.data().hasSeenLastPost;
                user.courses[index].recentPosts = doc.data().profileImage
                  ? doc.data().profileImage
                  : this.defaultGroupImage;
                user.courses[index].school_id = doc.data().school_id;
                user.courses[index].users = doc.data().users;
                if (doc.data().profileImage) {
                  user.courses[index].profileImage = doc.data().profileImage;
                } else {
                  user.courses[index].profileImage = this.defaultGroupImage;
                }
                user.courses[index].type = "courses";
                this.setGroupNotificationInfo({
                  group: user.courses[index],
                  notification: doc.data().recentPosts[
                    doc.data().recentPosts.length - 1
                  ],
                });
                this.$store.commit("user/setUser", user);
              });
          });
          if (user.directMessages) {
            user.directMessages.forEach((dm, index) => {
              db.collection("directMessages")
                .doc(dm.id)
                .get()
                .then((doc) => {
                  var otherUser = doc
                    .data()
                    .users.find((otherUser) => otherUser.user_id !== user.id);
                  user.directMessages[
                    index
                  ].hasSeenLastPost = doc.data().hasSeenLastPost;
                  user.directMessages[index].name = otherUser.name;
                  user.directMessages[index].profileImage =
                    otherUser.profileImage;
                  if (doc.data().recentPosts) {
                    user.directMessages[
                      index
                    ].recentPosts = doc.data().recentPosts;
                  } else {
                    user.directMessages[index].recentPosts = [];
                  }
                  user.directMessages[index].token = otherUser.token;
                  user.directMessages[index].type = "directMessages";
                  this.setGroupNotificationInfo({
                    group: user.directMessages[index],
                    notification: doc.data().recentPosts[
                      doc.data().recentPosts.length - 1
                    ],
                  });
                  this.$store.commit("user/setUser", user);
                });
            });
          }
          user.groups.forEach((group, index) => {
            db.collection("groups")
              .doc(group.id)
              .get()
              .then((doc) => {
                user.groups[index].hasSeenLastPost = doc.data().hasSeenLastPost;
                user.groups[index].name = doc.data().name;
                if (doc.data().recentPosts) {
                  user.groups[index].recentPosts = doc.data().recentPosts;
                } else {
                  user.groups[index].recentPosts = [];
                }
                user.groups[index].school_id = doc.data().school_id;
                user.groups[index].users = doc.data().users;
                user.groups[index].profileImage = doc.data().profileImage
                  ? doc.data().profileImage
                  : this.defaultGroupImage;
                user.groups[index].type = "groups";
                this.setGroupNotificationInfo({
                  group: user.groups[index],
                  notification: doc.data().recentPosts[
                    doc.data().recentPosts.length - 1
                  ],
                });
                if (doc.data().requests) {
                  user.groups[index].requests = doc.data().requests;
                }
                this.$store.commit("user/setUser", user);
              });
          });
          user.faculties.forEach((faculty, index) => {
            db.collection("faculties")
              .doc(faculty.id)
              .get()
              .then((doc) => {
                user.faculties[
                  index
                ].hasSeenLastPost = doc.data().hasSeenLastPost;
                user.faculties[index].name = doc.data().name;
                if (doc.data().recentPosts) {
                  user.faculties[index].recentPosts = doc.data().recentPosts;
                } else {
                  user.faculties[index].recentPosts = [];
                }
                user.faculties[index].school_id = doc.data().school_id;
                user.faculties[index].type = "faculties";
                user.faculties[index].profileImage = doc.data().profileImage
                  ? doc.data().profileImage
                  : this.defaultGroupImage;
                this.setGroupNotificationInfo({
                  group: user.faculties[index],
                  notification: doc.data().recentPosts[
                    doc.data().recentPosts.length - 1
                  ],
                });
                this.$store.commit("user/setUser", user);
              });
          });
          //await this.$store.commit("user/setUser", this.user);
          //this.setInitialNotifications();
        });
    },

    async setInitialCourse(id) {
      await db
        .collection("users")
        .doc(id)
        .get()
        .then((doc) => {
          if (doc.data().courses.length > 0) {
            this.course = doc.data().courses[0];
            this.course.type = "courses";
          } else if (doc.data().faculties.length > 0) {
            this.course = doc.data().faculties[0];
            this.course.type = "faculties";
          } else if (doc.data().groups.length > 0) {
            this.course = doc.data().groups[0];
            this.course.type = "groups";
          } else if (
            doc.data().directMessages &&
            doc.data().directMessages.length > 0
          ) {
            this.course = doc.data().directMessages[0];
            this.course.type = "directMessages";
            db.collection("directMessages")
              .doc(this.course.id)
              .get()
              .then((doc) => {
                this.course.name = doc
                  .data()
                  .users.find((user) => user.id !== id).name;
              });
          }
        });
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
